export const NoProfilePermissions = {
  id: 'no_profile',

  navbar: {
    view: false,
    profile: {
      edit: false,
      perfilBeta: false,
    },
  },

  projetos: {
    list: false,
    register: false,
    edit: false,
    approve: false,
    reprove: false,
    editFinished: false,
    remove: false,
    viewChecker: {
      professorGestor: false,
      coordenadorLocal: false,
    },
    filters: {
      situacao: false,
      coop: false,
    },
  },

  reembolsos: {
    list: false,
    register: false,
    edit: false,
    remove: false,
  },

  professores: {
    list: false,
    register: false,
    edit: false,
    approve: false,
    reprove: false,
    activate: false,
    deactivate: false,
    canRemove: false,
  },

  assessores: {
    list: false,
    register: false,
    edit: false,
    activate: false,
    deactivate: false,
    canRemove: false,
  },

  coordenadores: {
    list: false,
    register: false,
    edit: false,
    activate: false,
    deactivate: false,
    canRemove: false,
  },

  empresas: {
    list: false,
    register: false,
    edit: false,
    remove: false,
  },

  escolas: {
    list: false,
    register: false,
    edit: false,
    activate: false,
    deactivate: false,
    dadosDaEscola: {
      list: false,
      register: false,
      edit: false,
      duplicate: false,
      remove: false,
    },
    ideb: {
      list: false,
      register: false,
      edit: false,
      remove: false,
    },
  },

  relatorios: {
    generate: {
      projetos: false,
      'dados-cadastrais': false,
      'dados-gerais': false,
      'dados-do-programa': false,
      assessoria: false,
      'dados-do-ideb': false,
      contratos: false,
      escolas: false,
    },
  },

  materiaisPedagogicos: {
    list: false,
    download: false,
  },

  agendaAssessoresPedagogicos: {
    list: false,
    register: false,
    edit: {
      locked: false,
      unlocked: false,
    },
    lock: false,
    unlock: false,
    remove: [false, false, false, false, false],
  },

  dashboard: {
    generate: false,
  },

  contratos: {
    list: false,
    editEvenWhenDisabled: false,
    assessor: {
      edit: false,
      register: false,
      view: false,
      upload: false,
      changeUpload: false,
      changeStatus: false,
      analiseOperacional: {
        edit: false,
      },
      templates: {
        list: false,
        edit: false,
      },
    },
    entePublico: {
      downloadChecklist: false,
      edit: false,
      register: false,
      view: false,
      uploadNaoAssinado: false,
      uploadAssinado: false,
      uploadExtrato: false,
      changeUploadAssinado: false,
      changeUploadExtrato: false,
      changeUploadPlanoTrabalho: false,
      changeStatus: false,
      analiseOperacional: {
        edit: false,
      },
    },
    entePrivado: {
      edit: false,
      register: false,
      view: false,
      upload: false,
      changeUpload: false,
      changeStatus: false,
      analiseOperacional: {
        edit: false,
      },
      templates: {
        list: false,
        edit: false,
      },
    },
  },
};
